// src/components/ListStateBar.jsx
import React from 'react';
import { Menu } from '@headlessui/react';
import StoreDropdown from './StoreDropdown';

const ListStateBar = ({ 
  onSortChange,
  currentSort = 'Checked',
  lists = [],
  activeList,
  onListChange,
  onNewListClick,
  onOpenMetricsModal,
  onClearCheckedItems  // Nueva prop para limpiar items chequeados
}) => {
  const sortOptions = [
    'Checked',
    'Alphabet',
    'Low to high price',
    'High to low price'
  ];

  const handleSortChange = (sortOption) => {
    if (onSortChange) {
      onSortChange(sortOption);
    }
  };

  const handleClearClick = () => {
    if (onClearCheckedItems) {
      onClearCheckedItems();
    }
  };

  return (
    <div className="bg-white px-2 pt-3 pb-2">
      {/* Line 1: Sort by (Left) and List + Icons (Right) */}
      <div className="flex justify-between items-center">
        {/* Sort by Dropdown - Left */}
        <Menu as="div" className="relative inline-block text-left text-sm">
          <Menu.Button className="pt-1 pb-1 inline-flex items-center text-gray-800 hover:text-gray-900 focus:outline-none">
            <span className="text-sm">Sort by:</span>
            <span className="ml-1 font-bold">{currentSort}</span>
            <i className="fas fa-caret-down ml-1 text-xs text-gray-500"></i>
          </Menu.Button>
          <Menu.Items className="absolute left-0 mt-1 w-48 origin-top-left bg-white rounded-md shadow-lg border border-gray-200 z-50">
            <div className="py-1">
              {sortOptions.map((option) => (
                <Menu.Item key={option}>
                  {({ active }) => (
                    <button
                      onClick={() => handleSortChange(option)}
                      className={`w-full text-left px-3 py-2 text-sm ${
                        active ? 'bg-gray-50' : 'text-gray-700'
                      } ${currentSort === option ? 'text-purple-600 font-medium' : ''}`}
                    >
                      {option}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Menu>

        {/* Right side: Metrics Gear + Divider + Broom Icon + List Dropdown */}
        <div className="flex items-center gap-2">

          {/* List Dropdown */}
          <StoreDropdown
            lists={lists}
            activeList={activeList}
            onListChange={onListChange}
            onNewListClick={onNewListClick}
          />

          {/* Divider */}
          <div className="w-px h-5 bg-gray-300"></div>

          {/* Escobita para limpiar items chequeados */}
          <button
            onClick={handleClearClick}
            className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
            aria-label="Clear checked items"
            title="Remove all checked items from list"
          >
            <i className="fas fa-broom text-gray-500 text-sm"></i>
          </button>

        </div>
      </div>
    </div>
  );
};

export default ListStateBar;